<template>
  <el-scrollbar style="height:100%">
    <div class="game-container">
      <!-- <el-row class="game-header">

      </el-row>-->
      <Header index="1"></Header>
      <div class="list-banner"></div>
      <div style="width: 1518px;margin:0 auto;">
        <el-row class="game-location">
          <!-- <div class="breadcrumbs">
            当前位置：
            <a>游戏列表</a>
          </div>-->
          <div style="height:30px"></div>
          <div class="act-tle">游戏列表</div>
          <div style="height:20px;"></div>
        </el-row>
        <!-- <el-row class="game-sort">
          <ul class="list-rank-cate">
            <li class="current">
              <a>综合排序</a>
            </li>
            <li class>
              <a>
                入库时间
                <i class="ico ico-down1"></i>
              </a>
            </li>
          </ul>
          <search class="game-search" />
        </el-row>-->
        <div class="game-main">
          <el-row :gutter="10">
            <el-col
              :xs="24"
              :md="8"
              :sm="24"
              class="templete"
              v-for="tem in gameData"
              :key="tem.id"
            >
              <div class="con">
                <a :href="'/more?id='+tem.id" target="_blank">
                  <div class="c1">
                    <span>
                      <img :src="tem.coverImg.indexOf('http')>-1?tem.coverImg:'/api'+tem.coverImg" />
                    </span>
                  </div>
                  <div class="c2">
                    <div class="tit">
                      <a>{{tem.name}}</a>
                    </div>

                    <div class="info">
                      <span class="ex" :title="tem.schedule">测试情况：{{tem.schedule}}</span>
                      <span>运营商：{{tem.provider || '暂无'}}</span>
                    </div>
                    <div class="tag">
                      <a title="MMORPG">{{tem.cateId?cateObj[tem.cateId]: '暂无分类'}}</a>
                      <a title="MMORPG">{{tem.subjectId?subObj[tem.subjectId]: '暂无题材'}}</a>
                    </div>
                  </div>
                </a>
                <div class="c3">
                  <div class="channel">
                    <a :href="tem.videoLink" title="视频" target="_blank">
                      <i class="ico ico-video-s"></i>视频
                    </a>

                    <!-- <a
                :href="tem.coverImg.indexOf('http')>-1?tem.coverImg:'/api'+tem.coverImg"
                title="截图"
                target="_blank"
              >
                <i class="ico ico-pic-s"></i>截图
                    </a>-->
                    <!-- <a @click="handleClick(tem.banners)">
                <i class="ico ico-pic-s"></i>截图
                    </a>-->
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div style="height:16px;"></div>
          <div style="overflow:hidden">
            <el-row class="game-page">
              <el-pagination
                background
                :page-size="searchParams.pageSize"
                layout="total, prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
              ></el-pagination>
            </el-row>
          </div>
        </div>
        <div class="i-mtop" style="display:none;">
          <div class="i-m-content">
            <img class="i-logo" src="/static/img/logo.png" />
            <div class="i-text-box">
              <el-row>
                <!-- <a>dh社区discord</a>
          <a>dh社区twitter</a>
          <a>dh社区油管</a>
                <a>dh社区b站</a>-->
                <el-col :span="6" class="i-t-e">
                  <div class="i-m-text">discord</div>
                  <a href="https://discord.gg/p7QCHPntuf">Digitak Hunter社区</a>
                </el-col>
                <el-col :span="6" class="i-t-e">
                  <div class="i-m-text">推特</div>
                  <a href="https://twitter.com/DigitalHunterCN">@DigitalHunterCN</a>
                </el-col>
                <el-col :span="7" class="i-t-e">
                  <div class="i-m-text">公众号</div>
                  <a>关注DH链游资讯</a>
                </el-col>
                <el-col :span="6" class="i-t-e">
                  <div class="i-m-text">油管</div>
                  <a href="https://www.youtube.com/@DigitalHunter2023">@DigitalHunter2023</a>
                </el-col>
                <el-col :span="6" class="i-t-e">
                  <div class="i-m-text">b站</div>
                  <a>关注Digital Hunter链游公会</a>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

      <el-dialog title="游戏截图" width="70%" :visible.sync="dialogVisible">
        <el-carousel style="margin-top:-20px;" height="500px">
          <el-carousel-item v-for="(item,index) in banners" :key="index" height="500px">
            <div class="banner-tem" :style="`background-image: url(${item.imgUrl})`"></div>
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
      <div style="height:30px;"></div>
    </div>

    <Footer></Footer>
  </el-scrollbar>
</template>

<script>
import Search from './search'
import { getGameList, getSubjectList, getcateList } from '@/api/gameList'
import Header from '@/views/header.vue'
import Footer from '@/views/footer.vue'
export default {
  name: 'Game',
  components: {
    Search,
    Header,
    Footer
  },
  data () {
    return {
      gameData: [],
      subObj: {},
      cateObj: {},
      dialogVisible: false,
      searchParams: {
        page: 1,
        pageSize: 12
      },
      total: 0,
      banners: [
        {
          imgId: '1',
          imgUrl: 'static/img/t1.png'
        },
        {
          imgId: '2',
          imgUrl: 'static/img/t2.png'
        },
        {
          imgId: '3',
          imgUrl: 'static/img/t3.png'
        }
      ]
    }
  },
  watch: {

  },
  methods: {
    headerSearch () {
      getGameList(this.searchParams).then((data) => {
        this.gameData = data.games
        this.total = data.total
      })
      getSubjectList().then((data) => {
        const myobj1 = {}
        data.forEach(tem => {
          myobj1[tem.id] = tem.title
        })
        this.subObj = Object.assign({}, myobj1)
      })
      getcateList().then((data) => {
        const myobj2 = {}
        data.forEach(tem => {
          myobj2[tem.id] = tem.title
        })
        this.cateObj = Object.assign({}, myobj2)
      })
    },
    handleClick (arr) {
      if (arr.length) {
        this.banners = arr
      }
      this.dialogVisible = true
    },
    handleCurrentChange (curr) {
      // console.log(111222, curr)
      getGameList({
        page: curr,
        pageSize: this.searchParams.pageSize
      }).then((data) => {
        this.gameData = data.games
        this.total = data.total
      })
    }
  },
  created () {
    this.headerSearch()
  },
  destroyed () {

  },
}
</script>

<style lang="scss" scope>
.game-container {
  max-width: 1920px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  position: relative;
  background: url("/static/img/bg_01.jpg") center center no-repeat;
  // .game-header{
  //   padding: 25px 0;
  //   background: skyblue;
  // }
  .act-tle {
    width: 452px;
    height: 90px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    line-height: 90px;
    background: url("/static/img/title_bg.png") center center no-repeat;
    font-size: 38px;
    font-weight: bold;
    margin-bottom: 24px;
    color: black;
  }
  ul,
  li {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .game-location {
    overflow: hidden;
    font-size: 14px;
    color: #999;
    padding: 15px 0 0;
    .breadcrumbs a {
      color: #4277d0;
      margin: 0 5px;
      cursor: pointer;
    }
  }
  .game-sort {
    margin-top: 20px;
    line-height: 42px;
    height: 42px;
    background: #f7f7f7;
    font-size: 14px;
    padding: 0 5px 0 15px;
    ul {
      float: left;
      li {
        float: left;
        margin-right: 40px;
        a {
          color: #666;
        }
      }
    }
    .current a {
      color: #ff6000;
      font-weight: 700;
    }
    .ico-down1 {
      margin: 0 0 3px 5px;
      width: 5px;
      height: 10px;
      background: url("/static/img/sprite.png") no-repeat;
      background-position: 0 -165px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .game-page {
    // float: right;
    text-align: center;
    padding-top: 7px;
  }
  .game-main {
    padding: 40px 24px;
    background: #ffffff;
    box-shadow: 0 6px 12px 0 #0000001a;
    border-radius: 8px;
    .templete {
      border-bottom: 1px solid #eee;
      padding: 15px 0 20px;
      position: relative;
      .con {
        padding: 0 0 0 0;
        position: relative;
        .c1 {
          float: left;
          margin-right: 20px;
          padding-top: 5px;
          span {
            display: block;
            width: 160px;
            height: 90px;
            background: #000;
            overflow: hidden;
            img {
              width: 160px;
              height: auto;
            }
          }
        }
        .c2 {
          overflow: hidden;
          font-size: 14px;

          .tit {
            margin-bottom: 3px;
            font-size: 16px;
            font-weight: 700;
            padding-top: 4px;
          }
          .info {
            color: #999;
            overflow: hidden;
            margin-bottom: 5px;
            span {
              line-height: 24px;
              display: block;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              max-width: 95%;
            }
          }
          .tag a {
            float: left;
            line-height: 20px;
            padding: 0 7px;
            background: #a4b7d7;
            color: #fff;
            margin: 0 4px 4px 0;
          }
        }
        .c3 {
          position: absolute;
          right: 20px;
          bottom: 0;
          margin-top: -51px;
          .channel {
            width: 100px;
            text-align: center;
            position: relative;
            a {
              display: block;
              margin: 10px 0;
              line-height: 34px;
              font-size: 14px;
              border: 1px solid #e0e0e0;
              border-radius: 18px;
              background: rgba(255, 255, 255, 0.5);
              i {
                background: url("/static/img/sprite.png") no-repeat;
                margin: 0 7px 3px 0;
                display: inline-block;
                width: 12px;
                height: 12px;
                vertical-align: middle;
              }
              .ico-video-s {
                background-position: -35px -135px;
              }
              .ico-pic-s {
                background-position: -20px -135px;
              }
            }
          }
        }
      }
    }
    .templete:before {
      content: "";
      display: block;
      width: 0;
      border-top: 1px solid #609bff;
      position: absolute;
      left: 0;
      bottom: -1px;
      -webkit-transition: width 0.4s;
      transition: width 0.4s;
    }
  }
  .game-search {
    position: absolute;
    right: 13px;
    top: 0px;
    color: #666;
  }
  .banner-tem {
    width: 100%;
    height: 500px;
    background-size: cover;
    background-position: center center;
  }
  .i-mtop {
    height: 100px;
    margin-top: 20px;
    background: black;
    .i-m-content {
      width: 1100px;
      height: 100px;
      margin: 0 auto;
      position: relative;
    }
    .i-logo {
      position: absolute;
      height: 110px;
      width: auto;
      left: -15px;
      top: -11px;
    }
    .i-text-box {
      margin-left: 170px;
      padding: 10px 10px;
      overflow: hidden;
      .i-m-text {
        color: white;
        font-size: 14px;
      }
      a {
        white-space: nowrap;
        line-height: 1.5em;
        color: #656e6f;
        font-size: 14px;
        &:hover {
          color: #ff6000;
        }
      }
      .i-t-e {
        margin-bottom: 7px;
      }
    }
  }
  @media (max-width: 768px) {
    /*0~768*/
    .game-main .templete .con {
      padding: 0;
      .c1 {
        width: 100%;
        span {
          width: 100%;
          height: auto;
          img {
            width: 100%;
          }
        }
      }
      .c2 {
        width: 100%;
        padding-top: 20px;
      }
      .c3 {
        top: auto;
        bottom: -6px;
        right: 2px;
      }
    }
    .game-search {
      display: none;
    }
  }
}
.list-banner {
  height: 244px;
  background: url("/static/img/banner4.png") center center no-repeat;
}
</style>
<style lang="scss">
.game-container {
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background: none;
  }
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #9ed8f5;
}
</style>
